import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center",
  style: {
    "gap": "4px",
    "grid-gap": "4px"
  }
};
import { reactive, onMounted } from 'vue';
import { getById } from '@/api/modules/role';
export default {
  __name: 'RoleTag',
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info'
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    let roleInfo = reactive({
      id: $props.id,
      name: undefined
    });
    onMounted(() => {
      if (!$props.id) {
        throw new Error('username is required');
      }
      getById($props.id).then(res => {
        if (res.success) {
          roleInfo.id = res.data.id;
          roleInfo.name = res.data.name;
        }
      });
    });
    const onClose = () => {
      $emits('close', $props.id);
    };
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createBlock(_component_el_tag, {
        round: "",
        closable: $props.closable,
        type: __props.type,
        effect: "light",
        onClose: onClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_unref(roleInfo).name || __props.id), 1)])]),
        _: 1
      }, 8, ["closable", "type"]);
    };
  }
};